// extracted by mini-css-extract-plugin
export default {"nav_open":"navbar_nav_open__k+WiC","nav_close":"navbar_nav_close__GiA98"};